import React from "react";
import Spinner from "components/Common/Spinner";
import "./style.scss";

class Loading extends React.Component {
  getClassName() {
    let classString = "Loading ";

    if (this.props.customClassName) {
      classString += this.props.customClassName;
    }

    return classString;
  }

  render() {
    return (
      <div className={this.getClassName()}>
        <Spinner dark large />
      </div>
    );
  }
}

export default Loading;
